import { render, staticRenderFns } from "./CustomerFormPopup.vue?vue&type=template&id=3b750bda&scoped=true&"
import script from "./CustomerFormPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerFormPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFormPopup.vue?vue&type=style&index=0&id=3b750bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b750bda",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/CustomerFormPopup.vue
// module id = null
// module chunks = 